import { DataGridPro, GridColumns, GridCsvExportOptions, GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid-pro';
import React, { useEffect, useState } from 'react';
import { LoadingProgress } from 'src/common/store/types';
import { ReportingBatchState } from '../store/types';
import { DateTimeFormat, getLocalDateTime } from 'src/common';
import { Box, Grid, Paper, Typography } from '@mui/material';
import WO2Button from 'src/common/components/button/Button';
import { Download } from '@mui/icons-material';

interface Props {
  batch: ReportingBatchState;
  fetchBulkReportLogList: (page: number, pageSize: number) => void;
  fetchBulkReportLogListProgress: LoadingProgress;
}

export const ReportingBatchLogs = (props: Props) => {
  const [pageSize, setPageSize] = useState<number>(25);
  const [page, setPage] = useState<number>(0);

  const ReportingBatchLogsColumns: GridColumns = [
    { field: 'relatedUserId', headerName: 'Related User ID', flex: 1 },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <Typography>{params.row.description}</Typography>
          </Box>
        );
      },
    },
    { field: 'clientId', headerName: 'Client ID', flex: 1 },
    { field: 'clientName', headerName: 'Client Name', flex: 1 },
    {
      field: 'createdOn',
      headerName: 'Created On',
      flex: 1,
      valueFormatter: (params) => getLocalDateTime(params.value, DateTimeFormat.DateTimeShort),
    },
  ];

  useEffect(() => {
    props.fetchBulkReportLogList(page, pageSize);
  }, [page, pageSize]);

  const tableToolbar = () => {
    const apiRef = useGridApiContext();
    const handleExport = (options?: GridCsvExportOptions) => apiRef.current.exportDataAsCsv(options);

    return (
      <GridToolbarContainer sx={{ padding: 2, alignItems: 'center' }}>
        <Box flex={1} />
        <Box>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <WO2Button onClick={() => handleExport({ fileName: 'Logs' })} startIcon={<Download />}>
                Export
              </WO2Button>
            </Grid>
          </Grid>
        </Box>
      </GridToolbarContainer>
    );
  };

  return (
    <Grid container direction="column">
      <Grid item>
        <Paper elevation={4}>
          <DataGridPro
            initialState={{
              pagination: {
                page: 0,
                pageSize: 25,
              },
            }}
            components={{
              Toolbar: tableToolbar,
            }}
            checkboxSelection
            autoHeight
            pagination
            page={page}
            paginationMode="server"
            getRowId={(row) => row.id}
            rowCount={props.batch.paginatedReportLogs.totalNumberOfRecords}
            loading={props.fetchBulkReportLogListProgress.isLoading}
            onPageChange={(page: number) => {
              setPage(page);
            }}
            onPageSizeChange={(pageSize: number) => {
              setPageSize(pageSize);
            }}
            columns={ReportingBatchLogsColumns}
            rows={props.batch.paginatedReportLogs.results}
          />
        </Paper>
      </Grid>
    </Grid>
  );
};
